import { INavbarState } from '@modules/header/domain/interfaces/NavbarState';

type WithNavbarState = {
  NavbarSlice: INavbarState;
};
export const NavbarStateSelector = (state: WithNavbarState): INavbarState =>
  state.NavbarSlice;
